import { render } from "./About.vue?vue&type=template&id=6a9ba12a&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-6a9ba12a"

export default script